export function data (state) {
    return state.data
}

export function dataDefault(state) {
    return state.dataDefault
}

export function disableForm (state) {
    return state.disableForm
}

export function dataList (state) {
    return state.dataList
}

export function pagination (state) {
    return state.pagination
}

export function selectLookup (state) {
    return state.selectLookup
}

// export function selectLookup(state)
// {
//     return tag => {       
//         console.log('selectLookup',state.selectLookup); 
        
//         if (state.selectLookup.hasOwnProperty(tag)) {
//             return state.selectLookup[tag]
//         } else {
//             return [{value:'',label:''}]
//         }
//     }
// }